import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  ChangeDetectorRef,
} from "@angular/core";
import { CallCenterService } from "src/app/services/call-center.service";
import { AskApolloService } from "src/app/services/ask-apollo.service";
import { CommonService } from "src/app/services/common.service";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { CreateAppointmentDialogComponent } from "src/app/call-center/create-appointment-dialog/create-appointment-dialog.component";
import { MessageServiceService } from "src/app/services/message-service.service";
import { de } from "date-fns/locale";
import { compareAsc } from "date-fns";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DialogModule } from "primeng/dialog";
//import { CallBackLaterComponent } from "../call-back-later/call-back-later.component";
@Component({
  selector: "app-view-uhiddetails",
  templateUrl: "./view-uhiddetails.component.html",
  styleUrls: ["./view-uhiddetails.component.scss"],
})
export class ViewUHIDDetailsComponent implements OnInit, OnDestroy {
  //@ViewChild(CallBackLaterComponent ,{ static: false }) childComponent!: CallBackLaterComponent;
  selectedUHIDDetails: any;
  rescheduleDetails: any;
  isNewUser: boolean = false;
  CallerStatusAutoId = 0;
  callerId;
  leadId;
  currentMobileNumber: string;
  CallerMobileNumber: string;
  callType: number;
  tabStatus: any;
  loadingFlag: boolean = false;
  isAnyOperationDone = false;
  isFeedbackDone = false;
  //popup show hide flags

  isGeneralEnquiryOpen: boolean = false;
  createApptPopupOpen: boolean = false;

  CallBackApptPopupOpen: boolean = false;
  PackageInquiryPopupOpen: boolean = false;
  CallDropPopUpOpen: boolean = false;
  ConfirmedAppointmentPopUpOpen: boolean = false;
  FeedBacks: boolean = false;

  IrreleventPopupOpen: boolean = false;
  NotRespondingPopupOpen: boolean = false;
  NumberNotValidPopupOpen: boolean = false;
  AddUser: boolean = false;

  CreateHealthCheckApptPopupOpen: boolean = false;
  UHIDDetailsPopupOpen: boolean = true;
  RescheduleApptPopupOpen: boolean = false;
  itDoseModalPopUpOpen: boolean = false;
  CancelApptPopupOpen: boolean = false;
  WalkingPopupOpen: boolean = false;
  AskApolloHealthCheckPopupOpen: boolean = false;
  selectUhid$: Subscription;
  selectedCurrentState$: Subscription;
  feedBack: string;
  feedBackForm: FormGroup;
  feedBackMessage: string;
  selectedValue: string;
  feedBackText: boolean = false;
  prevSelected: any;
  position: string = "bottom-right";
  selectedBusiness: string;

  callBackPoupOpen: boolean = false;
  userData1: any;

  constructor(
    private callCenterService: CallCenterService,
    private messageService: MessageServiceService,
    private askApolloService: AskApolloService,
    private router: Router,
    private ref: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private commonService: CommonService
  ) {
    //this method get the selected uhid data from service
    this.selectUhid$ = this.callCenterService.selectedUHID.subscribe(
      (value) => {
        // debugger
        //  console.log("this.selectedUHIDDetail sub", this.selectedUHIDDetails);
        this.leadId = value.LeadId ? value.LeadId : 0;
        this.isNewUser = value.IsNewUser;
        this.callType = value.CallTypeId;
        this.CallerStatusAutoId = value.CallerStatusAutoId;
        this.callerId = value.CallerId;
        this.CallerMobileNumber = value.CallerMobileNumber;
        this.selectedUHIDDetails = value.UHIDDetails;
        console.log("this.selectedUHIDDetails", this.selectedUHIDDetails);
        this.currentMobileNumber = this.isNewUser
          ? value.UHIDDetails["phoneNo"]
          : value.UHIDDetails["mobileNumber"];
        this.currentMobileNumber =
          this.currentMobileNumber == undefined
            ? value.CallerMobileNumber
            : this.currentMobileNumber;
      }
    );

    //this method get the status of operation done in any child tab like appt book, call status updating etc.
    this.selectedCurrentState$ =
      this.callCenterService.selectedCurrentState.subscribe((value) => {
        // console.log(value)
        if (value && value.isOperationDone) {
          this.tabStatus = value; //callStatusId,callStatusName,statusMessage
          this.isAnyOperationDone = true;
          this.isFeedbackDone = true;
          this.createApptPopupOpen = false;
          this.CallBackApptPopupOpen = false;
          this.CreateHealthCheckApptPopupOpen = false;
          this.RescheduleApptPopupOpen = false;
          this.CancelApptPopupOpen = false;
          this.UHIDDetailsPopupOpen = true;
          this.isGeneralEnquiryOpen = false;
          this.itDoseModalPopUpOpen = false;
          this.PackageInquiryPopupOpen = false;
          this.WalkingPopupOpen = false;
          this.AskApolloHealthCheckPopupOpen = false;
          debugger;
          // if(this.tabStatus.callStatusId == 25 || this.tabStatus.callStatusId == 28
          //   || this.tabStatus.callStatusId == 35 || this.tabStatus.callStatusId == 18
          //   || this.tabStatus.callStatusId == 27 || this.tabStatus.callStatusId == 23){
          this.getAppointmentsHistoryOnMobileNumber(this.CallerMobileNumber); //currentMobileNumber
          // }
        } else {
          this.isAnyOperationDone = false;
          this.isFeedbackDone = false;
        }
      });
  }
  ngOnDestroy() {
    this.isAnyOperationDone = false;
    this.isFeedbackDone = false;
    let tabStatus = { ...this.tabStatus };
    tabStatus.isOperationDone = false;
    this.callCenterService.afterCompleteOperationKnowTheStatus(tabStatus);
    this.selectedCurrentState$.unsubscribe();
    this.selectUhid$.unsubscribe();
  }

  userData: any;
  feedbackBU: [];
  showHide: boolean = false;
  DiagnosticsPopMenuList: boolean = false;
  DialysisPopMenuList: boolean = false;
  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("LOGGED_USER_INFO"));
    this.userData1 = JSON.parse(
      localStorage.getItem("CurrentOutBoundCallMobileNumber")
    );

    // debugger;
    this.feedbackBU = JSON.parse(
      localStorage.getItem("LOGGED_USER_INFO")
    ).bussinessUnitName.split(",");
    //console.log((this.feedbackBU.toString() == "Diagnostics"),"condition")
    if (this.feedbackBU.toString() == "Diagnostics") {
      this.DiagnosticsPopMenuList = true;
    } else if (this.feedbackBU.toString() == "Dialysis") {
      this.DialysisPopMenuList = true;
    }

    console.log(this.feedbackBU, "BU");
    if (this.feedbackBU.length > 1) {
      this.showHide = true;
    } else {
      this.showHide = false;
      this.selectedBusiness = this.feedbackBU.toString();
      console.log(this.selectedBusiness, "BU");
    }

    this.getAllAppointmentStatus(this.callType);
    if (this.tabStatus) {
      setTimeout(() => {
        let tabStatus = { ...this.tabStatus };
        tabStatus.isOperationDone = false;
        this.callCenterService.afterCompleteOperationKnowTheStatus(tabStatus);
      }, 20000);
    }

    this.feedBackForm = this.formBuilder.group({
      feedBack: ["", Validators.required],
      feedBackMessage: ["", Validators.required],
      feedbackBusinessUnit: ["", Validators.required],
    });

    if (this.selectedValue == "2") {
      this.feedBackText = true;
      this.feedBackForm.get("feedBackMessage").enable();
    } else {
      this.feedBackForm.get("feedBackMessage").enable();
    }
  }

  ngAfterContentChecked(): void {
    this.ref.detectChanges();
  }

  ngAfterViewInit() {}
  AppoinmentStatusByName(index, item) {
    return item.statusName;
  }

  // Method to open the corresponding popup
  openPopup(popupType: string) {
    this.resetAllPopups();
    switch (popupType) {
      case "callBackPopUp":
        this.CallBackApptPopupOpen = true;
        this.AddUser = false;
        this.CallDropPopUpOpen = false;
        this.ConfirmedAppointmentPopUpOpen = false;
        this.IrreleventPopupOpen = false;
        this.NotRespondingPopupOpen = false;
        this.NumberNotValidPopupOpen = false;
        this.createApptPopupOpen = false;
        this.PackageInquiryPopupOpen = false;
        this.FeedBacks =false;
        break;
      case "callDrop":
        this.CallDropPopUpOpen = true;
        this.AddUser = false;
        this.CallBackApptPopupOpen = false;
        this.ConfirmedAppointmentPopUpOpen = false;
        this.IrreleventPopupOpen = false;
        this.NotRespondingPopupOpen = false;
        this.NumberNotValidPopupOpen = false;
        this.createApptPopupOpen = false;
        this.PackageInquiryPopupOpen = false;
        this.FeedBacks =false;
        break;
      case "confirmedAppointment":
        this.ConfirmedAppointmentPopUpOpen = true;
        this.CallDropPopUpOpen = false;
        this.AddUser = false;
        this.CallBackApptPopupOpen = false;
        this.IrreleventPopupOpen = false;
        this.NotRespondingPopupOpen = false;
        this.NumberNotValidPopupOpen = false;
        this.createApptPopupOpen = false;
        this.PackageInquiryPopupOpen = false;
        this.FeedBacks =false;
        break;
        case "feedBacks":
        this.CallDropPopUpOpen = false;
        this.ConfirmedAppointmentPopUpOpen = false;
        this.AddUser = false;
        this.CallBackApptPopupOpen = false;
        this.IrreleventPopupOpen = false;
        this.NotRespondingPopupOpen = false;
        this.NumberNotValidPopupOpen = false;
        this.createApptPopupOpen = false;
        this.PackageInquiryPopupOpen = false;
        this.FeedBacks =true;
        break;
      case "irrelevantLead":
        this.IrreleventPopupOpen = true;
        this.AddUser = false;
        this.CallBackApptPopupOpen = false;
        this.CallDropPopUpOpen = false;
        this.ConfirmedAppointmentPopUpOpen = false;
        this.NotRespondingPopupOpen = false;
        this.NumberNotValidPopupOpen = false;
        this.createApptPopupOpen = false;
        this.PackageInquiryPopupOpen = false;
        this.FeedBacks =false;

        break;
      case "notResponding":
        this.NotRespondingPopupOpen = true;
        this.AddUser = false;
        this.CallBackApptPopupOpen = false;
        this.CallDropPopUpOpen = false;
        this.ConfirmedAppointmentPopUpOpen = false;
        this.IrreleventPopupOpen = false;
        this.NumberNotValidPopupOpen = false;
        this.createApptPopupOpen = false;
        this.PackageInquiryPopupOpen = false;
        this.FeedBacks =false;

        break;
      case "numberNotValid":
        this.NumberNotValidPopupOpen = true;
        this.AddUser = false;
        this.CallBackApptPopupOpen = false;
        this.CallDropPopUpOpen = false;
        this.ConfirmedAppointmentPopUpOpen = false;
        this.IrreleventPopupOpen = false;
        this.NotRespondingPopupOpen = false;
        this.createApptPopupOpen = false;
        this.PackageInquiryPopupOpen = false;
        this.FeedBacks =false;

        break;
      case "createAppt":
        this.createApptPopupOpen = true;
        this.AddUser = false;
        this.CallBackApptPopupOpen = false;
        this.CallDropPopUpOpen = false;
        this.ConfirmedAppointmentPopUpOpen = false;
        this.IrreleventPopupOpen = false;
        this.NotRespondingPopupOpen = false;
        this.PackageInquiryPopupOpen = false;
        this.NumberNotValidPopupOpen = false;
        this.FeedBacks =false;

        break;
      case "packagePopUp":
        this.PackageInquiryPopupOpen = true;
        this.AddUser = false;
        this.CallBackApptPopupOpen = false;
        this.CallDropPopUpOpen = false;
        this.ConfirmedAppointmentPopUpOpen = false;
        this.IrreleventPopupOpen = false;
        this.NotRespondingPopupOpen = false;
        this.createApptPopupOpen = false;
        this.NumberNotValidPopupOpen = false;
        this.FeedBacks =false;

        break;
      case "addUser":
        this.AddUser = true;
        this.PackageInquiryPopupOpen = false;
        this.CallBackApptPopupOpen = false;
        this.CallDropPopUpOpen = false;
        this.ConfirmedAppointmentPopUpOpen = false;
        this.IrreleventPopupOpen = false;
        this.NotRespondingPopupOpen = false;
        this.createApptPopupOpen = false;
        this.NumberNotValidPopupOpen = false;
        this.FeedBacks =false;

        break;
      default:
        console.log("No matching popup found");
    }
  }

  DisableDiv() {
    this.CallDropPopUpOpen = false;
    this.ConfirmedAppointmentPopUpOpen = false;
    this.IrreleventPopupOpen = false;
    this.NotRespondingPopupOpen = false;
    this.NumberNotValidPopupOpen = false;
    this.createApptPopupOpen = false;
    this.PackageInquiryPopupOpen = false;
    this.AddUser = false;
  }
  // Reset all popup states
  resetAllPopups() {
    this.CallBackApptPopupOpen = false;
    //this.callBackLaterPopupOpen = false;
    // this.callDropPopupOpen = false;
    this.createApptPopupOpen = false;
    this.PackageInquiryPopupOpen = false;
  }

  getSelectedBU(event: any) {
    //debugger;
    //console.log(event.target.value, "BU TEST");
    this.selectedBusiness = event.target.value;
  }

  disableOrEnableForm(flag) {
    // 1 enable , 0 disable
    if (flag == 1) {
      this.loadingFlag = false;
      //this.ref.detectChanges();
      //this.createAppointmentForm.enable();
    } else {
      this.loadingFlag = true;
      //this.createAppointmentForm.disable();
    }
  }

  apptStatusFlag: boolean = false;
  appointmentStatusData: any[];
  getAllAppointmentStatus(callType) {
    this.apptStatusFlag = true;
    debugger;
    this.commonService.getAllAppointmentStatus(callType).subscribe(
      (res: any) => {
        if (res.response && res.response.length > 0) {
          if (this.DiagnosticsPopMenuList == true) {
            this.appointmentStatusData = [
              {
                callCenterStatusId: 33,
                statusName: "Complaint / Feedbacks",
              },
              {
                callCenterStatusId: 37,
                statusName: "IT Dose",
              },
              {
                callCenterStatusId: 34,
                statusName: "Not Contacted",
              },
              {
                callCenterStatusId: 32,
                statusName: "Tele / Virtual Consultation",
              },
              {
                callCenterStatusId: 19,
                statusName: "WalkIn",
              },
              {
                callCenterStatusId: 20,
                statusName: "General Enquiry",
              },
              {
                callCenterStatusId: 28,
                statusName: "Package Enquiry",
              },
            ];
            //console.log(this.appointmentStatusData, "data");
          } else if (this.DialysisPopMenuList == true) {
            this.appointmentStatusData = [
              {
                callCenterStatusId: 34,
                statusName: "Not Contacted",
              },
              {
                callCenterStatusId: 32,
                statusName: "Tele / Virtual Consultation",
              },
              {
                callCenterStatusId: 19,
                statusName: "WalkIn",
              },
              {
                callCenterStatusId: 20,
                statusName: "General Enquiry",
              },
            ];
          } else {
            this.appointmentStatusData = res.response;
          }
        }
        this.getAppointmentsHistoryOnMobileNumber(this.currentMobileNumber);
        this.apptStatusFlag = false;
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve call status data from server "
        );
      }
    );
  }
  //from ask apollo appt history

  // Component Properties
  currentAppointmentsHistory: any[] = []; // Initialize as empty array
  pastAppointmentHistory: any[] = []; // Initialize as empty array
  apptsLoading: boolean = false;

  getAppointmentsHistoryOnMobileNumber(mobileNo) {
    // Reset arrays first to clear any previous data

    this.currentAppointmentsHistory = [];
    this.pastAppointmentHistory = [];

    // Set loader to true before API call
    this.apptsLoading = true;

    let payload = {
      MobileNumber: mobileNo,
    };

    this.askApolloService
      .getAppointmentsHistoryOnMobileNumberFromAskApollo(payload)
      .subscribe(
        (res: any) => {
          debugger;
          // Store the entire response structure with both UpcomingAppointments and PastAppointments
          if (res.isSuccess && res.response) {
            localStorage.setItem(
              "AppointmentInformation",
              JSON.stringify(res.response) // Store the entire response object
            );
          }
          if (res.isSuccess) {
            if (res.response !== null) {
              this.currentAppointmentsHistory =
                res.response.UpcomingAppointments !== null &&
                res.response.UpcomingAppointments.length > 0
                  ? res.response["UpcomingAppointments"].sort((a, b) => {
                      const aCancelled = !!a.cancelledOn;
                      const bCancelled = !!b.cancelledOn;

                      // If one is cancelled and the other is not, move cancelled to end
                      if (aCancelled && !bCancelled) return 1;
                      if (!aCancelled && bCancelled) return -1;

                      // If both are either cancelled or not, sort by createdOn descending
                      const aTime = new Date(
                        a.createdOn.split("-").reverse().join("-")
                      ).getTime();
                      const bTime = new Date(
                        b.createdOn.split("-").reverse().join("-")
                      ).getTime();
                      return bTime - aTime;
                    })
                  : [];

              this.pastAppointmentHistory =
                res.response.PastAppointments.length > 0
                  ? res.response["PastAppointments"]
                  : [];
            }
          }
          // Always turn off loading when done
          this.apptsLoading = false;
          this.router.navigate(["/base/call-center/patient-dashboard"]);
        },
        (error) => {
          // Handle error case
          this.apptsLoading = false;
          this.messageService.showErrorMessage(
            "Unable to retrieve appointment history data from server"
          );
        }
      );
  }
  //old method
  // getAppointmentsHistoryOnMobileNumberFromCRMDb(mobileNo) {
  //   this.appointmentsHistory = [];
  //   let payload = {
  //     "MobileNumber": mobileNo
  //   }
  //   this.askApolloService.getAppointmentsHistoryOnMobileNumber(payload)
  //     .subscribe((res: any) => {
  //       if (res.isSuccess) {
  //         //this.appointmentsHistory = res.response;
  //         let tempObj = res.response;
  //         let previousAppts = [];
  //         let currentAppts = [];
  //         tempObj.forEach(function (appt) {
  //           let date = new Date();
  //           date.setDate(date.getDate() - 1);
  //           let arr = [];
  //           if (appt["appointmentDate"].includes("/"))
  //             arr = appt["appointmentDate"].split('/');  //mm/dd/yyyy
  //           else
  //             arr = appt["appointmentDate"].split('-');  //dd/mm/yyyy
  //           let apptDate = null;
  //           if (appt["appointmentDate"].includes("/"))
  //             apptDate = new Date(arr[2].split(" ")[0], arr[0], arr[1], 0, 0, 0, 0);     //yyyy,mm,dd,hh,mm,ss
  //           else
  //             apptDate = new Date(arr[2].split(" ")[0], arr[1], arr[0], 0, 0, 0, 0);     //yyyy,mm,dd,hh,mm,ss
  //           if (compareAsc(new Date(apptDate), date) > 0) {
  //             currentAppts.push(appt);
  //           } else {
  //             previousAppts.push(appt);
  //           }
  //         });
  //         this.appointmentsHistory['currentAppointments'] = currentAppts;
  //         this.appointmentsHistory['previousAppointments'] = previousAppts;
  //       }
  //       //this.isLoading= false;
  //     }, error => {
  //       //this.isLoading= false;
  //       this.messageService.showErrorMessage("Unable to retrieve appt history data from server ");
  //     })
  // }

  updateStatus(data) {
    this.callCenterService.UpdateCallStatus({
      CallTypeId: this.callType,
      CallStatus: data,
      LeadId: this.leadId,
      IsNewUser: this.isNewUser,
      CallerStatusAutoId: this.CallerStatusAutoId,
      CallerId: this.callerId,
      //"RescheduleDetails": this.rescheduleDetails,
      UHIDDetails: this.selectedUHIDDetails,
    });

    if (data.callCenterStatusId == 28) {
      //package enquiry
      this.CallBackApptPopupOpen = false;
      this.createApptPopupOpen = false;
      this.UHIDDetailsPopupOpen = false;
      this.isGeneralEnquiryOpen = false;
      this.RescheduleApptPopupOpen = false;
      this.CancelApptPopupOpen = false;
      this.AskApolloHealthCheckPopupOpen = false;
      this.CreateHealthCheckApptPopupOpen = false;
      this.itDoseModalPopUpOpen = false;
      this.PackageInquiryPopupOpen = true;
      this.SubmitPackageDetailsInfo();
    } else if (data.callCenterStatusId == 35) {
      // ask apollo HC Appt
      this.AskApolloHealthCheckPopupOpen = true;
      this.createApptPopupOpen = false;
      this.CallBackApptPopupOpen = false;
      this.UHIDDetailsPopupOpen = false;
      this.isGeneralEnquiryOpen = false;
      this.RescheduleApptPopupOpen = false;
      this.CancelApptPopupOpen = false;
      this.PackageInquiryPopupOpen = false;
      this.itDoseModalPopUpOpen = false;
      this.CreateHealthCheckApptPopupOpen = false;
    } else if (data.callCenterStatusId == 36) {
      //corp health check book appointment
      this.CreateHealthCheckApptPopupOpen = true;
      this.createApptPopupOpen = false;
      this.CallBackApptPopupOpen = false;
      this.UHIDDetailsPopupOpen = false;
      this.isGeneralEnquiryOpen = false;
      this.RescheduleApptPopupOpen = false;
      this.CancelApptPopupOpen = false;
      this.itDoseModalPopUpOpen = false;
      this.PackageInquiryPopupOpen = false;
    } else if (data.callCenterStatusId == 37) {
      //IT Dose
      this.CreateHealthCheckApptPopupOpen = false;
      this.createApptPopupOpen = false;
      this.CallBackApptPopupOpen = false;
      this.UHIDDetailsPopupOpen = false;
      this.isGeneralEnquiryOpen = false;
      this.RescheduleApptPopupOpen = false;
      this.CancelApptPopupOpen = false;
      this.itDoseModalPopUpOpen = true;
      this.PackageInquiryPopupOpen = false;
    } else if (data.callCenterStatusId == 19) {
      //Walking
      this.WalkingPopupOpen = true;
      this.CreateHealthCheckApptPopupOpen = false;
      this.createApptPopupOpen = false;
      this.CallBackApptPopupOpen = false;
      this.UHIDDetailsPopupOpen = false;
      this.isGeneralEnquiryOpen = false;
      this.RescheduleApptPopupOpen = false;
      this.CancelApptPopupOpen = false;
      this.itDoseModalPopUpOpen = false;
      this.PackageInquiryPopupOpen = false;
    } else {
      //create appt,reschedule and remaining operations expect above.
      this.createApptPopupOpen = true;
      this.CallBackApptPopupOpen = false;
      this.UHIDDetailsPopupOpen = false;
      this.isGeneralEnquiryOpen = false;
      this.RescheduleApptPopupOpen = false;
      this.CancelApptPopupOpen = false;
      this.PackageInquiryPopupOpen = false;
      this.itDoseModalPopUpOpen = false;
      this.AskApolloHealthCheckPopupOpen = false;
      this.CreateHealthCheckApptPopupOpen = false;
    }
  }
  backButtonEvent() {
    ``;
    // if(this.createApptPopupOpen){
    //  this.backToUHIDDetailsTab();
    // }else if(this.isGeneralEnquiryOpen){
    //   this.backToUHIDDetailsTab();
    // }
    this.backToUHIDDetailsTab();
  }

  backToUHIDDetailsTab() {
    this.createApptPopupOpen = false;
    this.CallBackApptPopupOpen = false;
    this.CreateHealthCheckApptPopupOpen = false;
    this.isGeneralEnquiryOpen = false;
    this.RescheduleApptPopupOpen = false;
    this.CancelApptPopupOpen = false;
    this.itDoseModalPopUpOpen = false;
    this.PackageInquiryPopupOpen = false;
    this.WalkingPopupOpen = false;
    this.AskApolloHealthCheckPopupOpen = false;
    this.UHIDDetailsPopupOpen = true;
  }
  viewHistory() {
    this.callCenterService.shareDataBwPopupAndViewHistoryComponent({
      isRequestFormPopUp: true,
      leadId: this.leadId,
      callType: this.callType,
      isNewUser: this.isNewUser,
      CallerMobileNumber: this.CallerMobileNumber,
      UHIDMobileNumber:
        this.callType == 1
          ? this.CallerMobileNumber.toString().replace("+91", "")
          : this.CallerMobileNumber.toString().replace("+91", ""),
      CallerStatusAutoId: this.CallerStatusAutoId,
      CallerId: this.callerId,
      PatientDetails: this.selectedUHIDDetails,
    });
    if (this.callType == 1) {
      this.router.navigate(["/base/call-center/view-history"], {
        queryParams: {
          mobile:
            this.callType == 1
              ? this.CallerMobileNumber.toString().replace("+91", "")
              : this.selectedUHIDDetails.phoneNo.toString().replace("+91", ""),
          isReport: false,
        },
      });
    } else {
      this.router.navigate(["/base/call-center/view-history"], {
        queryParams: {
          mobile:
            this.callType == 1
              ? this.CallerMobileNumber.toString().replace("+91", "")
              : this.CallerMobileNumber.toString().replace("+91", ""),
          isReport: false,
        },
      });
    }
  }

  patientHistory() {
    this.router.navigate(["/base/call-center/patient-dashboard"]);
  }

  ProceedToRescheduleAppointment(apptDetails) {
    let callStatusObj =
      this.callType == 1
        ? { callCenterStatusId: 16, statusName: "Rescheduling" }
        : { callCenterStatusId: 16, statusName: "Rescheduling" };
    this.rescheduleDetails = apptDetails;
    this.createApptPopupOpen = false;
    this.CallBackApptPopupOpen = false;
    this.CreateHealthCheckApptPopupOpen = false;
    this.UHIDDetailsPopupOpen = false;
    this.itDoseModalPopUpOpen = false;
    this.isGeneralEnquiryOpen = false;
    this.RescheduleApptPopupOpen = true;
    this.PackageInquiryPopupOpen = false;
    this.WalkingPopupOpen = false;
    this.callCenterService.ProceedToReschedule({
      CallTypeId: this.callType,
      CallStatus: callStatusObj,
      LeadId: this.leadId,
      IsNewUser: this.isNewUser,
      CallerStatusAutoId: this.CallerStatusAutoId,
      CallerId: this.callerId,
      RescheduleDetails: this.rescheduleDetails,
    });
  }

  ProceedToCancelAppointment(apptDetails) {
    let callStatusObj =
      this.callType == 1
        ? { callCenterStatusId: 23, statusName: "Cancel Appointment" }
        : { callCenterStatusId: 23, statusName: "Cancel Appointment" };
    this.rescheduleDetails = apptDetails;
    this.createApptPopupOpen = false;
    this.CallBackApptPopupOpen = false;
    this.itDoseModalPopUpOpen = false;
    this.UHIDDetailsPopupOpen = false;
    this.isGeneralEnquiryOpen = false;
    this.RescheduleApptPopupOpen = false;
    this.CancelApptPopupOpen = true;
    this.PackageInquiryPopupOpen = false;
    this.WalkingPopupOpen = false;
    this.CreateHealthCheckApptPopupOpen = false;
    this.callCenterService.ProceedToCancelAppt({
      CallTypeId: this.callType,
      CallStatus: callStatusObj,
      LeadId: this.leadId,
      IsNewUser: this.isNewUser,
      CallerStatusAutoId: this.CallerStatusAutoId,
      CallerId: this.callerId,
      RescheduleDetails: this.rescheduleDetails,
    });
  }

  //resetPkgEnquiryForm:boolean = false;
  SubmitPackageDetailsInfo() {
    //this.resetPkgEnquiryForm= false;

    let callStatusObj =
      this.callType == 1
        ? { callCenterStatusId: 28, statusName: "Package Enquiry" }
        : { callCenterStatusId: 28, statusName: "Package Enquiry" };
    this.callCenterService.ProceedToPackageInquiry({
      CallTypeId: this.callType,
      CallStatus: callStatusObj,
      LeadId: this.leadId,
      IsNewUser: this.isNewUser,
      CallerStatusAutoId: this.CallerStatusAutoId,
      CallerId: this.callerId,
      UHIDDetails: this.selectedUHIDDetails,
    });
  }

  getFeedMessage(selected) {
    // console.log(selected,"sell")
    if (selected.target.value == "2") {
      this.feedBackText = true;
      this.selectedValue = "2";
      this.feedBackForm.get("feedBackMessage").enable();
    } else if (selected.target.value == "1" || selected.target.value == "3") {
      this.feedBackText = false;
      this.selectedValue = "1";
      this.feedBackForm.get("feedBackMessage").disable();
    }

    if (this.showHide) {
      this.feedBackForm.controls["feedbackBusinessUnit"].enable();
    } else {
      this.feedBackForm.controls["feedbackBusinessUnit"].disable();
    }
  }

  submitFeedBack(feedBackData) {
    this.isFeedbackDone = false;
    // let UserId = JSON.parse(localStorage.getItem('LOGGED_USER_INFO')).roleId
    //console.log(UserId);

    if (this.feedBackForm.valid) {
      let formDataValues = this.feedBackForm.value;
      //console.log("selectedUHIDDetails", this.selectedUHIDDetails)
      //console.log("userData",this.userData.bussinessUnitName);
      let bussinessUnitName = this.userData.bussinessUnitName;

      let payload = {
        mobile: this.selectedUHIDDetails.mobileNumber
          ? this.selectedUHIDDetails.mobileNumber
          : this.selectedUHIDDetails.phoneNo,
        PatientName:
          this.selectedUHIDDetails.firstName +
          this.selectedUHIDDetails.lastName,
        FeedBackID: formDataValues.feedBack,
        FeedBackName:
          formDataValues.feedBack == 1
            ? "Satisfied"
            : formDataValues.feedBack == 2
            ? "Not Satisfied"
            : "None",
        Remarks: formDataValues.feedBackMessage,
        BusinessUnit: this.selectedBusiness,
        CreatedBy: 0,
        CreatedIp: "string",
        CallType: this.callType,
        CallTypeText: this.callType == 1 ? "Inbound Call" : "Outbound Call",
      };
      this.disableOrEnableForm(0);
      this.callCenterService.FeedBackDetails(payload).subscribe(
        (res: any) => {
          this.messageService.showSuccess(res.response["statusMessage"]);
          this.disableOrEnableForm(1);
        },
        (error) => {
          this.messageService.showErrorMessage("Unable to Send FeedBack");
          this.disableOrEnableForm(1);
        }
      );
    }
  }
}
